module.exports = __webpack_public_path__ + "static/media/squared.400c2eba.jpg";